import { onReady } from "./utils/on-ready";

export class CountyReacoutOfficeMap {
    public static htmlId = 'county-reachout-office-map';
    public static htmlTemplate = `<div class="f-flex f-b-b f-p-b-8px" style="justify-content: space-between; align-items: center;">
        <span class="f-ifb-logo-mark f-w-60px f-h-40px"></span>
        <button onclick="closeOfficeDetails()" style="background: #FFCEAB; border: none; border-radius:100px; font-size: 24px; cursor: pointer; padding: 0px 7px; color:#fff;">
            &times;
        </button>
    </div>
    <div class="f-p-12px">
        <a target="_blank" href="{{OfficeMapLink}}"><h2 class="f-title-large f-t-red f-m-y-12px">{{Name}}</h2></a>
        <p class="f-t-12px f-p-b-8px f-flex">
            <span class="material-symbols-outlined f-t-red f-t-18px f-p-r-12px">location_on</span>
            {{Address}}
        </p>
        <button onclick="closeOfficeDetails()"
                class="mdc-button mdc-button--primary mdc-button--unelevated f-m-t-12px border-radius-100">
            Close
        </button>
    </div>`;
    constructor() {
        onReady(() => {
            this.initMap(CountyReacoutOfficeMap.htmlTemplate);
        });
    }

    initMap = (template) => {
        let map;
        let markers = new Array();
        let bounds;
        let officesArray;
        let f = (document.getElementById('myHiddenArray') as any);
        if (f != undefined && f != null) {
            f = f.value;
        }
        let latitude = parseFloat("0");
        let longitude = parseFloat("0");

        bounds = new google.maps.LatLngBounds();

        if (f != undefined && f != null) {
            officesArray = JSON.parse(f);

            if (officesArray.length > 1) {
                officesArray.forEach(function (officeLocation) {
                    latitude += parseFloat(officeLocation.Geo.Latitude);
                    longitude += parseFloat(officeLocation.Geo.Longitude);
                });
            }
            else if (officesArray.length == 1) {
                latitude += parseFloat(officesArray[0].Geo.Latitude);
                longitude += parseFloat(officesArray[0].Geo.Longitude);
            }
            else {
                latitude += parseFloat(officesArray.Geo.Latitude);
                longitude += parseFloat(officesArray.Geo.Longitude);
            }

            if (latitude == 0 || longitude == 0) {
                latitude = (39.791) + -0.02;
                longitude = -86.148 + -0.02;
            } else {
                latitude = (latitude / officesArray.length) + 0.28;
                longitude = (longitude / officesArray.length);
            }

            var mapCenter = new google.maps.LatLng({ lat: latitude, lng: longitude });
            
            // Initialize the map
            map = new google.maps.Map(document.getElementById("officeMap"), {
                center: mapCenter, // Center around downtown
                zoom: 12, // Default zoom level for 5-mile radius
                mapTypeId: 'terrain', // Set the map type to 'terrain'
                styles: [
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f7f7f7" // Set the background color to light gray
                            }
                        ]
                    }
                ]
            });
            console.log("Map Center (Lat, Long)", latitude, longitude);
           

            const displayOfficeDetails = function displayOfficeDetails(office) {
                const officeDetailsContainer = document.getElementById("officeDetails");
                officeDetailsContainer.style.display = "block";

                // Replace placeholders with actual data
                const populatedTemplate = template
                    .replace('{{Name}}', office.Name || 'Office Name Not Available')
                    .replace('{{Address}}', office.Address || 'Address Not Available')
                    .replace('{{Hours}}', office.Hours || 'No Hours Available')
                    .replace('{{OfficeMapLink}}', office.OfficeMapLink || '#');

                // Inject populated template into the container
                officeDetailsContainer.innerHTML = populatedTemplate;
            }

            const clearMarkers : any = function() {
                markers.forEach((marker) => marker.setMap(null));
                markers = [];
            }

            const addMarkerToMap: any = function(officeDetails, radius) {
                clearMarkers();

                officeDetails.forEach((office, index) => {
                    if (office.OfficeCode === "999" || office.Name === "New Service Center") {
                        return;
                    }

                    if (!office.Geo.Latitude || !office.Geo.Longitude) {
                        return;
                    }

                    const name = office.OfficeDescription || "Office Name Not Available";
                    const address = office.Address_Formatted || "Address Not Available";
                    const officeMapLink = office.OfficeMapLink;

                    const position = new google.maps.LatLng(parseFloat(office.Geo.Latitude), parseFloat(office.Geo.Longitude));

                    const marker = new google.maps.Marker({
                        position: position,
                        map: map,
                        title: name,
                    });

                    marker.addListener("click", () => {
                        displayOfficeDetails({ Name: name, Address: address, OfficeMapLink: officeMapLink });
                    });

                    markers.push(marker);
                });

                if (officeDetails.length > 0) {
                    const bounds = new google.maps.LatLngBounds();
                    officeDetails.forEach((office) => {
                        if (office.Latitude && office.Longitude) {
                            bounds.extend(new google.maps.LatLng(parseFloat(office.Latitude), parseFloat(office.Longitude)));
                        }
                    });
                    map.fitBounds(bounds);

                    if (radius === 5) {
                        map.setZoom(12);
                    }
                }
            }

            addMarkerToMap(officesArray, 5);

            for (var i = 0; i < markers.length; i++) {

                bounds.extend(markers[i].getPosition());
            }

            //center the map to a specific spot (city)
            map.setCenter({ lat: latitude, lng: longitude });

            //center the map to the geometric center of all markers
            map.setCenter(bounds.getCenter());

            map.fitBounds(bounds);

            google.maps.event.addListenerOnce(map, 'bounds_changed', function (event) {
                this.setZoom(map.getZoom() - 1);

                if (this.getZoom() > 15) {
                    this.setZoom(15);
                }

                if (this.getZoom() < 5) {
                    this.setZoom(5);
                }
            });

            map.fitBounds(bounds);
        }


    }
}